import { V2OrderSideType } from '../../types/base';

export const CommunityEvent = {
  OrderFormInfoTabClick: 'order_form_info_tab_click',
  FeedPageUserProfileClick: 'feed_page_user_profile_click',
  FeedPositionDeleteClick: 'feed_position_delete_click',
  FeedPositionCancelClick: 'feed_position_cancel_click',
  FeedTopPnlTraderClick: 'feed_top_pnl_trader_click',
  FeedPositionReactionClick: 'feed_position_reaction_click',
  OrderConfirmPageShareToFeedBoxClick: 'order_confirm_page_share_to_feed_box_click',
  OrderConfirmPageCloseImmediatelyBoxClick: 'order_confirm_page_close_immediately_box_click',
  OrderConfirmationDoneClick: 'order_confirmation_done_click',
  OrderConfirmationPageView: 'order_confirmation_page_view',
  ShareToFeedBottomSheetView: 'share_to_feed_bottom_sheet_view',
  FeedShareButtonClick: 'feed_share_button_click',
  UsernameChangeErrorView: 'username_change_error_view', // Only log when 30 days name changed error occurred

  // feed post
  FeedSignupToPostClick: 'feed_signup_to_post_click',
  ShareYourThoughtsClick: 'share_your_thoughts_click',
  SharePostClick: 'share_post_click',
  FeedPositionElipsClick: 'feed_position_elips_click',
  ReportPostClick: 'report_post_click',
  FeedTypeClick: 'feed_type_click',

  // live pnl shoutout
  TopLivePnlCardClick: 'top_live_pnl_card_click',

  // top traders onboarding
  TopTradersModalView: 'top_traders_modal_view',
  TopTradersModalContinueClick: 'top_traders_modal_continue_click',
  TopTradersModalFollowClick: 'top_traders_modal_follow_click',
  TopTradersModalMoreClick: 'top_traders_modal_more_click',
} as const;

export type FeedEventLocation = 'trade_feed_tab' | 'profile_feed_tab';

export interface CommunityEventDataType {
  [CommunityEvent.OrderFormInfoTabClick]: {
    trade_type: 'perpetual' | 'spot';
    symbol: string;
    tab_type: string;
  };
  [CommunityEvent.FeedPageUserProfileClick]: {
    profile_id?: string;
    profile_ranking?: string;
    profile_username?: string;
    symbol: string;
    leverage?: number;
    side?: 'buy' | 'sell';
    position_status?: 'open' | 'close';
    realized_pnl?: number;
    realized_pnl_percentage?: number;
    is_influencer: boolean;
  };
  [CommunityEvent.FeedPositionDeleteClick]: {
    profile_id?: string;
    profile_ranking?: string;
    profile_username?: string;
    symbol: string;
    leverage?: number;
    side?: 'buy' | 'sell';
    position_status?: 'open' | 'close';
    realized_pnl?: number;
    realized_pnl_percentage?: number;
  };
  [CommunityEvent.FeedPositionCancelClick]: {
    profile_id?: string;
    profile_ranking?: string;
    profile_username?: string;
    symbol: string;
    leverage?: number;
    side?: 'buy' | 'sell';
    position_status?: 'open' | 'close';
    realized_pnl?: number;
    realized_pnl_percentage?: number;
  };
  [CommunityEvent.FeedTopPnlTraderClick]: {
    profile_id?: string;
    profile_ranking?: string;
    profile_username?: string;
    realized_pnl?: number;
    realized_pnl_percentage?: number;
  };
  [CommunityEvent.FeedPositionReactionClick]: {
    profile_id?: string;
    profile_ranking?: string;
    profile_username?: string;
    symbol: string;
    leverage?: number;
    side?: 'buy' | 'sell';
    position_status?: 'open' | 'close';
    reaction: 'ROCKET' | 'BROKEN_HEART';
    realized_pnl?: number;
    realized_pnl_percentage?: number;
    event_location: FeedEventLocation;
  };
  [CommunityEvent.OrderConfirmPageShareToFeedBoxClick]: {
    is_checked: boolean;
  };
  [CommunityEvent.OrderConfirmPageCloseImmediatelyBoxClick]: {
    is_checked: boolean;
  };
  [CommunityEvent.OrderConfirmationDoneClick]: {
    share_feed: boolean;
    symbol: string;
    trade_type: 'perpetual' | 'spot';
    side: 'buy' | 'sell';
    close_immediately: boolean;
    close_type: 'partial_close' | 'full_close';
    realized_pnl?: number;
    realized_pnl_percentage?: number;
    is_airdrop?: boolean;
    order_type?: 'market_order' | 'limit_order' | 'trigger_price_order' | 'trigger_time_order';
  };
  [CommunityEvent.OrderConfirmationPageView]: {};
  [CommunityEvent.ShareToFeedBottomSheetView]: {};
  [CommunityEvent.FeedShareButtonClick]: {
    button_text: string;
  };
  // feed post
  [CommunityEvent.FeedSignupToPostClick]: {};
  [CommunityEvent.ShareYourThoughtsClick]: {};
  [CommunityEvent.SharePostClick]: {
    latest_trade: boolean;
    position_id?: string;
    upload_type: 'new' | 'edited';
    post_message: string;
  };
  [CommunityEvent.FeedPositionElipsClick]: {
    profile_id?: string;
    profile_ranking?: string;
    profile_username?: string;
    symbol: string;
    leverage?: number;
    side?: 'buy' | 'sell';
    position_status?: 'open' | 'close';
    feed_id: string;
  };
  [CommunityEvent.ReportPostClick]: {
    feed_id: string;
    // use CommunityFeedItemAbuseType in api types
    report_type: string;
  };
  [CommunityEvent.FeedTypeClick]: {
    feed_type: 'feed' | 'trades';
  };
  // live pnl shoutout
  [CommunityEvent.TopLivePnlCardClick]: {
    symbol: string;
    profile_id: string;
    profile_username: string;
    unrealized_pnl_percentage: number;
    unrealized_pnl: number;
    side: V2OrderSideType;
  };

  // top traders onboarding
  [CommunityEvent.TopTradersModalFollowClick]: {
    profile_id: string;
    profile_username: string;
    follow_type: 'follow' | 'unfollow';
  };
}
